module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "ro-copy",
    on: {
      "click": function($event) {
        _vm.copyText(_vm.copyData)
      }
    }
  }, [_c('div', {
    staticClass: "ro-copy__overlay ro-copy__overlay--default",
    class: [{
      'show': !_vm.showCopied
    }]
  }, [_c('span', [_c('span', [_vm._v("Kviknummer: ")]), _vm._v(" "), _c('span', [_vm._v(" " + _vm._s(_vm.display) + " ")])]), _vm._v(" "), _c('svg', {
    attrs: {
      "width": "14",
      "height": "16",
      "viewBox": "0 0 14 16",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M10.3158 0H0V11.6364H1.47368V1.45455H10.3158V0ZM14 2.90909H2.94737V16H14V2.90909ZM12.5263 14.5455H4.42105V4.36364H12.5263V14.5455Z",
      "fill": "#3C3C3C"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "ro-copy__overlay",
    class: [{
      'show': _vm.showCopied
    }]
  }, [_c('span', [_vm._v("Værdi kopieret")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /Users/fyrstenberg/Documents/Limbo/Roskilde-Handelsskole-Website-2023/frontend/~/vue-loader/lib/template-compiler.js?{"id":"data-v-5935979a"}!./scripts/ro-copy/RoCopy.html
// module id = 367
// module chunks = 1